'use client';

import { useState, ReactNode } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

interface ExpandCollapseProps {
  title: string;
  children: ReactNode;
  defaultExpanded?: boolean;
  id?: string;
  highlight?: boolean;
}

const Expand = ({
  title,
  children,
  defaultExpanded = false,
  id,
  highlight = true,
}: ExpandCollapseProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div
      id={id}
      className={`rounded-xl border ${isExpanded && highlight ? ' border-white' : ' border-zinc-700'}`}
    >
      <button
        className="w-full px-4 py-3 flex items-center justify-between font-semibold focus:outline-none"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className="font-blod text-left">{title}</span>
        {isExpanded ? (
          <ChevronUp className="flex-shrink-0" size={24} />
        ) : (
          <ChevronDown className="flex-shrink-0" size={24} />
        )}
      </button>
      <div
        className={`px-4 pb-3 [&>*:first-child]:mt-0 [&>*:last-child]:mb-0 ${isExpanded ? 'block' : 'hidden'}`}
      >
        {children}
      </div>
    </div>
  );
};

export { Expand };
